import { render, staticRenderFns } from "./bottomCenter.vue?vue&type=template&id=4edefc9d&scoped=true"
import script from "./bottomCenter.vue?vue&type=script&lang=js"
export * from "./bottomCenter.vue?vue&type=script&lang=js"
import style0 from "./bottomCenter.vue?vue&type=style&index=0&id=4edefc9d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4edefc9d",
  null
  
)

export default component.exports